import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { defineCustomElements } from '@revolist/revogrid/loader';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowser()
  .bootstrapModule(AppModule)
  // eslint-disable-next-line no-console
  .catch(err => console.error(err));

defineCustomElements();
